import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import api from "./api";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { useNavigate } from "react-router-dom";



function AddDeal() {
    const navigate = useNavigate();
  const [formData, setFormData] = useState({
    buyer: "",
    bales: "",
    sauda: "",
    candyrate: "",
    quality: "",
    dealperiods: "",
    terms: "",
    remarks: "",
    seller: "",
    station: "",
    date: "", // assuming you want to keep the same key as in your DB
    dalali: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    console.log("Submitting deal with data:", formData);

    // 1️⃣ Save deal in backend (DB only, no PDF)
    const res = await api.post("/addDeal", formData);
    console.log("✅ Deal saved:", res.data);

    // 2️⃣ Load template image from /public
    // put deal-template.jpg OR deal-template.png inside /frontend/public/
    const imageUrl = "/deal-template.jpg"; 
    const response = await fetch(imageUrl);

    if (!response.ok) {
      throw new Error(`Failed to load template image: ${response.status}`);
    }

    const imgBytes = await response.arrayBuffer();

    // 3️⃣ Create PDF
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595, 842]); // A4 size
    const { height } = page.getSize();

    // 4️⃣ Detect format (JPG vs PNG) and embed
    let image;
    const firstByte = new Uint8Array(imgBytes)[0];
    if (firstByte === 0xFF) {
      // JPEG starts with 0xFF 0xD8
      image = await pdfDoc.embedJpg(imgBytes);
    } else {
      // assume PNG
      image = await pdfDoc.embedPng(imgBytes);
    }

    page.drawImage(image, {
      x: 0,
      y: 0,
      width: 595,
      height: 842,
    });

    // 5️⃣ Add dynamic text
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontSize = 14;
   const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }); // Aug
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

// Use this in PDF drawText
page.drawText(formatDate(formData.date), {
  x: 430,
  y: height - 231,
  size: 10,   // smaller font size (adjust as needed)
  font: boldFont,
  color: rgb(0, 0, 0),
});
page.drawText(`${formData.buyer}`, {
  x: 300,
  y: height - 280,
size: 13, 
  font: boldFont,
  color: rgb(83/255, 177/255, 199/255), // ✅ valid range 0–1
});
    page.drawText(`${formData.seller}`, { x: 300, y: height - 300, size: 13, 
  font: boldFont,
  color: rgb(83/255, 177/255, 199/255), });
    page.drawText(`${formData.station}`, { x: 300, y: height - 324, size: 13,font, color: rgb(0,0,0) });
    page.drawText(`${formData.candyrate}`, { x: 300, y: height - 347, size: 13,font: boldFont,color: rgb(83/255, 177/255, 199/255),});
    page.drawText(`${formData.bales}`, { x: 300, y: height - 374, size: 13,font, color: rgb(0,0,0) });
    page.drawText(`${formData.quality}`, { x: 300, y: height - 407, size: 13,font, color: rgb(0,0,0) });
    page.drawText(`${formData.sauda}`, { x: 300, y: height - 442, size: 13,font, color: rgb(0,0,0) });
    
    page.drawText(`${formData.dealperiods}`, { x: 300, y: height - 467, size: 13,font, color: rgb(0,0,0) });
       // page.drawText(`${formData.date}`, { x: 50, y: height - 390, size: 13,font: boldFont, color: rgb(0,0,0) });
    page.drawText(`${formData.terms}`, { x: 300, y: height - 493, size: 13,font, color: rgb(0,0,0) });
    page.drawText(`${formData.remarks}`, { x: 300, y: height - 520, size: 13,font, color: rgb(0,0,0) });

    // 6️⃣ Save & Download PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    // window.open(url);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `deal_${Date.now()}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    navigate("/add-deal"); // Redirect to the same page after submission
    window.location.reload();

    console.log("✅ PDF generated & downloaded");
  } catch (err) {
    console.error("❌ Error generating PDF:", err);
    alert("Failed to generate PDF");
  }
};



  return (
    <div className="container mt-5">
      <div className="card shadow-lg border-0 rounded-4">
        <div className="card-header bg-gradient text-white text-center rounded-top-4" 
             style={{ background: "linear-gradient(90deg, #007bff, #df950cff)",color: "#d62323ff", 
    textShadow: "1px 1px 2px rgba(0, 0, 0, 0.81)"  }}>
          <h3 className="mb-0" >➕ Add New Deal</h3>
        </div>

        <div className="card-body p-4">
          <form onSubmit={handleSubmit} className="row g-4">

                    <div className="col-md-6">
<label className="form-label fw-bold">
  📅 Deal Date <span style={{ color: "red" }}>*</span>
</label>  <input
    type="date"
    className="form-control rounded-3 shadow-sm"
    name="date"   // keep the same key if your DB expects it in "terms"
    value={formData.date}
    onChange={handleChange}
    required
    
  />
</div>
            
            {/* Buyer */}
            <div className="col-md-6">
              <label className="form-label fw-bold">👤 Buyer<span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                name="buyer"
                value={formData.buyer}
                onChange={handleChange}
                placeholder="Enter buyer name"
                required
                
              />
            </div>
             {/* Seller */}
            <div className="col-md-6">
              <label className="form-label fw-bold">🏭 Seller<span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                name="seller"
                value={formData.seller}
                onChange={handleChange}
                placeholder="Enter seller name"
                required
                
              />
            </div>

            {/* Bales */}
            <div className="col-md-6">
              <label className="form-label fw-bold">📦 Bales<span style={{ color: "red" }}>*</span></label>
              <input
                type="number"
                className="form-control rounded-pill shadow-sm"
                name="bales"
                value={formData.bales}
                onChange={handleChange}
                placeholder="Number of bales"
                required
                
              />
            </div>

            {/* Station */}
            <div className="col-md-6">
              <label className="form-label fw-bold">🚉 Station<span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                name="station"
                value={formData.station}
                onChange={handleChange}
                placeholder="Enter station"
                required
                
              />
            </div>

            {/* Sauda */}
            <div className="col-md-6">
              <label className="form-label fw-bold">📑 Sauda</label>
              <textarea
                className="form-control rounded-3 shadow-sm"
                name="sauda"
                rows="3"
                value={formData.sauda}
                onChange={handleChange}
                placeholder="Enter sauda details"
                
              ></textarea>
            </div>

            {/* Candy Rate */}
            <div className="col-md-6">
              <label className="form-label fw-bold">💰 Candy Rate<span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                name="candyrate"
                value={formData.candyrate}
                onChange={handleChange}
                placeholder="Enter candy rate"
                required
                
              />
            </div>

             <div className="col-md-6">
              <label className="form-label fw-bold">💰 Brokerage<span style={{ color: "red" }}>*</span></label>
              <input
                type="number"
                className="form-control rounded-pill shadow-sm"
                name="dalali"
                value={formData.dalali}
                onChange={handleChange}
                placeholder="Enter Brokerage amount"
                required
                
              />
            </div>

            {/* Quality */}
            <div className="col-md-6">
              <label className="form-label fw-bold">⭐ Quality</label>
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                name="quality"
                value={formData.quality}
                onChange={handleChange}
                placeholder="Enter quality"
                
              />
            </div>

            {/* Deal Periods */}
            <div className="col-md-6">
              <label className="form-label fw-bold">📆 Deal Periods</label>
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                name="dealperiods"
                value={formData.dealperiods}
                onChange={handleChange}
                placeholder="Enter deal periods"
                
              />
            </div>

            {/* Terms */}
            <div className="col-md-6">
              <label className="form-label fw-bold">📋 Terms</label>
              <textarea
                className="form-control rounded-3 shadow-sm"
                name="terms"
                rows="3"
                value={formData.terms}
                onChange={handleChange}
                placeholder="Enter deal terms"
                
              ></textarea>
            </div>

    


            {/* Remarks */}
            <div className="col-md-6">
              <label className="form-label fw-bold">📝 Remarks</label>
              <textarea
                className="form-control rounded-3 shadow-sm"
                name="remarks"
                rows="3"
                value={formData.remarks}
                onChange={handleChange}
                placeholder="Any remarks"
                
              ></textarea>
            </div>

           

            

            {/* Submit Button */}
            <div className="col-12 text-center mt-3">
              <button type="submit" className="btn btn-lg btn-success px-5 rounded-pill shadow">
                ✅ Add Deal
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddDeal;
